export default __webpack_public_path__ + "static/media/image 74.49cc5be0.webp";